export default __webpack_public_path__ + "static/media/mobileLogo.97045b1a.png";